import { useMutation, useQueryClient } from 'react-query';

import { invitationsApi } from 'src/Services/API';

export const useDeleteInvitation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (invitationId: string) => {
      return invitationsApi.invitationsControllerDelete(invitationId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['fetch-members']);
    },
  });
};
